import configAWS from '../configAWSSDK';

const setup = () => {
  const AWS = configAWS();
  return new AWS.S3();
};

export default setup;
